export const isMobile = () =>
    typeof window !== 'undefined' &&
    (typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1);

export const isiPad = () => typeof navigator !== 'undefined' && navigator.userAgent.match(/iPad/i) != null;

export const isDesktop = () => typeof window !== 'undefined' && window.innerWidth > 1256;

export const getDeviceType = () => (isiPad() ? 'iPad' : isMobile() ? 'mobile' : isDesktop() ? 'desktop' : 'unknown');
